export default "__VITE_ASSET__Bf17Miev__"